module.exports = __webpack_public_path__ + "man-1.svg?a7e7a2e504f78067a73c4346ec24c270";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man-1.svg
// module id = 54
// module chunks = 0